import { is } from 'immutable';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import svtDataSdkClient from '../../../client/dataLake';
import env from '../../env';
import {
    continueWatchingActiveSelector,
    continueWatchingItemsSelector,
} from '../../reducers/continueWatching.js';
import { getContentoAbTestVariants } from '../../utils/abiskoUtils';
import { generateListTracking } from '../../utils/contentoUtils.js';
import { isBrowser } from '../../utils/environment.js';
import get from '../../utils/get.js';
import ContentoQuery, { ContentoData, ContentoLoading } from '../Contento/ContentoQuery.js';
import Recommendations, { Loading } from '../Recommendations/Recommendations.jsx';
import RecommendationsQuery from './PersonalRecommendations.graphql';
import { createListTrackingOnClick } from '../../utils/statistics/clientStatistics';

// AB Personalized genres oct 2020
export function extractIds(items) {
    return items
        .filter((item) => (item.movie && item.videoId) || (!item.movie && item.titleArticleId))
        .map((item) => (item.movie ? item.videoId.toString() : item.titleArticleId.toString()));
}

class TipsForYou extends Component {
    shouldComponentUpdate(nextProps) {
        return (
            nextProps.continueWatchingIsActive !== this.props.continueWatchingIsActive ||
            !is(nextProps.continueWatchingItems, this.props.continueWatchingItems)
        );
    }

    render() {
        const { continueWatchingIsActive, continueWatchingItems, contentoAbTestVariants } = this.props;

        if (!continueWatchingIsActive || !continueWatchingItems || continueWatchingItems.size === 0) {
            return null;
        }

        const historyIds = extractIds(continueWatchingItems.toJS().slice(0, 100));

        return (
            <ContentoQuery
                query={RecommendationsQuery}
                variables={{
                    history: historyIds,
                    clientId: env.FLAG_ENABLE_BALTHAZAR_CLIENT_ID ? svtDataSdkClient.getClientId() : null,
                    abTestVariants: contentoAbTestVariants,
                    includeFullOppetArkiv: env.FLAG_ENABLE_ALL_OA,
                }}
                skip={!isBrowser()}
            >
                <ContentoData>
                    {(data) => {
                        const items = get(data, 'personalRecommendations.items', []);
                        const listTracking = generateListTracking(get(data, 'personalRecommendations'));

                        const onItemClick = createListTrackingOnClick(listTracking);

                        return (
                            <>
                                <Recommendations items={items.slice(0, 6)} onItemClick={onItemClick} />
                            </>
                        );
                    }}
                </ContentoData>
                <ContentoLoading>
                    <Loading />
                </ContentoLoading>
            </ContentoQuery>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        continueWatchingIsActive: continueWatchingActiveSelector(state),
        continueWatchingItems: continueWatchingItemsSelector(state),
        contentoAbTestVariants: getContentoAbTestVariants(state),
    };
};

export default connect(mapStateToProps)(TipsForYou);
